import Swal from "sweetalert2";
export const handleCouponCreate = async (couponData, {fetchData, setCreatingCoupon, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
    try {
        setCreatingCoupon(true);
        await coupons.create(couponData);
        fetchData();
        await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Coupon created successfully!",
        confirmButtonColor: "#1e3a8a",
        });
    } catch (error) {
        console.error("Error creating coupon:", error);
        await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create coupon. Please try again.",
        confirmButtonColor: "#1e3a8a",
        });
    } finally {
        setCreatingCoupon(false);
    }
};